module.exports = __webpack_public_path__ + "static/affirming.3787074f.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/affirming.jpg
// module id = 1003
// module chunks = 2